import api from "@/services/api.service";
import { required ,email, maxLength } from 'vuelidate/lib/validators'

export default {
  name: 'edit-profile',
  components: {},
  props: [],
  data () {
    return {
      caption:"Edit Profile",
      campaigns:[],
      formField:{first_name:'',last_name:'',email:'',phone:''},
      submitStatus: null,
      roles:[]
    }
  },
  computed: {    
  },
  watch:{          
  },
  mounted () {
  },
  validations: {
    formField: {
      first_name: {
        required
      },
      last_name: {
        required
      },
      email:{
        required,email
      },
      phone:{
        required, maxLength: maxLength(14)
      }
    }
  },
  created(){      
    this.getUser();    
  },
  methods: {
    acceptNumber(e) {       
      if(e){
        let char = String.fromCharCode(e.keyCode);        
        if(/^[A-Za-z]+$/.test(char)) {
          e.preventDefault(); }
        else {
        var x = this.formField.phone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,5})/);
        this.formField.phone = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');        
        }
      }
    },
    makeToast(message = '',title='Alert',variant='warning') {
      this.toastCount++
      this.$root.$bvToast.toast(message, {
        title:title,
        variant:variant,
        autoHideDelay: 3000
      })
    },      
    async getUser(){        
      let response = await api.post('/users/list',{'id':this.$route.params.id});
      if(!response)
        this.makeToast("Something went to wrong please try again", 'Alert', 'danger', 6000)

      if(response.status == 'success'){
        this.formField = response.data;  
      }else{
       this.makeToast(response.message,'Alert','danger');
     }
   },
   async edit(){
    this.$v.$touch();
    if (this.$v.$invalid) {
      this.submitStatus = 'ERROR'
    } else{
      let response = await api.post('admin/users/update', this.formField);
      if (!response)
        this.makeToast("Something went to wrong please try again", 'Alert', 'danger', 6000)

      if(response.status=='success'){
        this.makeToast(response.message,'Success','success');        
      }else{
        for(var error in response.errors){
          this.makeToast(response.errors[error],'Alert','danger');
        }
      }
    }
  }
}
}


